import {Component, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserInfoModel} from '../../../services/models/user-info.model';
import {UserService} from '../../../services/user.service';
import {NavController} from '@ionic/angular';
import {NavService} from '../../../services/nav.service';


@Component({
    selector: 'app-social-page',
    templateUrl: './social-page.component.html',
    styleUrls: ['./social-page.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})

export class SocialPageComponent implements OnInit {

    userInfo: UserInfoModel = null;
    url = null;

    constructor(
        public sanitizer: DomSanitizer,
        private userService: UserService,
        private navService: NavService
    ) {}

    ngOnInit() {
        this.userInfo = this.userService.getCurrentUserInfo(false);
        (this.userInfo !== null ? Promise.resolve(this.userInfo) : this.userService.getUserInfo())
            .then((userInfo) => {
                this.userInfo = userInfo;
                if (!!this.userInfo.dashboard
                    && !!this.userInfo.dashboard.enabled_social
                    && this.userInfo.dashboard.social_url) {
                    this.url = userInfo.dashboard.social_url + '?i=' + this.userInfo.meet_user;
                } else {
                    this.navService.navigateHome();
                }
            });
    }
}
